'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';

import chooseImage from '@/public/images/services/heating-installation/chooseImage.jpg';
import installationImage from '@/public/images/services/heating-installation/installation-proccess.jpg';
import certified from '@/public/images/services/heating-installation/certified.png';
import customized from '@/public/images/services/heating-installation/customized.png';
import pricing from '@/public/images/services/heating-installation/pricing.png';
import feedback from '@/public/images/services/heating-installation/feedback.png';
import customerService from '@/public/images/services/heating-installation/customerService.png';
import trusted from '@/public/images/services/heating-installation/trusted.png';

const data = {
  title: 'Heating Installation in San Diego',
  description:
    'Stay warm and cozy with our professional heating system installation services. We ensure your home remains at the perfect temperature during the chilly seasons - and we also offer reliable <a href="https://tytum.com/services/heating-and-air/heating">heating maintenance services in San Diego</a> to keep your system running smoothly long after installation.',
  image: image,
  offer_title: '',
  offer_data: [
    {
      title: 'Our Heating Installation Services',
      description: '',
      list: [
        {
          title: 'Residential Heating Installation',
          description:
            'Ensure your home is warm and cozy with our professional residential heating installation services in San Diego. From new furnace setups to ductless heating systems, we tailor energy-efficient solutions to meet your family’s needs.',
        },
        {
          title: 'Commercial Heating Installation',
          description:
            'Ensure your business stays productive and cozy with our professional commercial heating installations. We specialize in robust systems designed to handle larger spaces efficiently and reliably.',
        },
        {
          title: 'Furnace Installation',
          description:
            'Upgrade your heating with a modern, energy-efficient furnace. Our team ensures precise installation for dependable warmth during the coldest months.',
        },
        {
          title: 'Heat Pump Installation',
          description:
            'Enjoy everyday comfort with a heat pump system that delivers both heating and cooling. This versatile and energy-saving option is perfect for keeping a stable indoor environment.',
        },
        {
          title: 'Central Heating System Installation',
          description:
            'Achieve even and consistent warmth throughout your property with our central heating system installations. Ideal for residential and commercial spaces, they are built for superior performance and dependability.',
        },
      ],
    },
  ],
  banner_title: `“Reliable Warmth, Expertly Installed”`,
  banner_description: `Tytum’s heating system installation services offer peace of mind. We ensure your home stays warm with energy-efficient systems tailored to your
comfort needs.`,
  banner_with_button: true,
  why_title: '',
  why_description: ``,
  why_items: [
    /* {
      title: 'We offer same-day service for your convenience.',
      description: '',
    },
    {
      title:
        'Our certified and experienced technicians ensure top-quality work.',
      description: '',
    },
    {
      title: 'Enjoy affordable pricing with no hidden fees.',
      description: '',
    },
    {
      title: 'We guarantee 100% satisfaction with our services.',
      description: '',
    }, */
  ],
  why_footerText: '',
  extraContent: [
    {
      title:
        'What Makes Tytum the Best Choice for Heating Installation in San Diego?',
      description: '',
      image: chooseImage,
      items: [
        {
          title: 'Certified and Experienced Technicians',
          image: certified,
          description:
            'Our experienced professionals bring a wealth of expertise to every installation project. We ensure precision and high-quality workmanship tailored to your needs.',
        },
        {
          title: 'Customized Heating Solutions',
          image: customized,
          description:
            'We recognize that each home has its own individuality. That’s why we offer personalized heating installation options, from energy-efficient systems to smart thermostat integration, designed to suit your specific requirements.',
        },
        {
          title: 'Competitive and Transparent Pricing',
          image: pricing,
          description:
            'We provide competitive rates without compromising quality. With our honest and clear pricing, you’ll always know what to expect—no surprises or hidden charges.',
        },
        {
          title: 'Customer Satisfaction',
          image: feedback,
          description:
            'We value your satisfaction above all else. We are dedicated to ensuring you’re completely happy with the new heating system, offering follow-up support and solutions if needed.',
        },
        {
          title: 'Comprehensive Installation Services',
          image: customerService,
          description:
            'From ductless heating to advanced zoning systems, we handle all aspects of your heating installation. Our attention to detail guarantees an efficient, long-lasting solution.',
        },
        {
          title: 'Trusted Local Expertise',
          image: trusted,
          description:
            'As a reliable provider for heating installation in San Diego, we understand the needs of our community. We deliver personalized service with a focus on comfort and energy efficiency.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Types of Heating Systems We Install',
      description: '',
      items: [
        {
          title: 'Furnaces (Gas and Electric)',
          description:
            'Enhance the comfort of your home with a new electric or gas furnace. These systems provide dependable and energy-efficient heating to keep you cozy throughout the colder season.',
        },
        {
          title: 'Heat Pumps',
          description:
            'Install a versatile heat pump that seamlessly handles both heating and cooling. Heat pumps are highly energy-efficient and ideal for year-round temperature control.',
        },
        {
          title: 'Ductless Mini-Split Heating Systems',
          description:
            'Enjoy precise temperature control and energy efficiency with ductless mini-split systems. These are ideal for homes that don’t have ductwork in place or areas needing individual climate control. If you’re searching for <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">mini split AC installation near me</a>, our experts deliver seamless setups designed for maximum comfort and efficiency.',
        },
        {
          title: 'Radiant Heating Systems',
          description:
            'Experience consistent, even warmth with radiant heating systems. They use hot water or electric elements to heat floors or walls, providing cozy comfort throughout your space.',
        },
        {
          title: 'Boilers',
          description:
            'Ensure steady and efficient heating with a modern boiler. Boilers provide hot water or steam to heat radiators or underfloor heating, making them a perfect choice for consistent comfort.',
        },
        {
          title: 'Smart Thermostats',
          description:
            "Upgrade your system with a smart thermostat to conserve energy while boosting comfort. These devices adapt to your preferences and automatically regulate your home's temperature for maximum efficiency.",
        },
        {
          title: 'Zoning Systems',
          description:
            'Optimize comfort in your home by installing zoning systems. These systems enable independent temperature control in various areas, enhancing efficiency and lowering energy consumption.',
        },
        {
          title: 'Programmable Thermostats',
          description:
            'Opt for a programmable thermostat to adjust temperature changes during the day depending on your schedule. This option is great for saving energy without compromising on comfort.',
        },
        {
          title: 'Hydronic Heating Systems',
          description:
            'Install a hydronic system for even and gentle warmth. These systems distribute hot water through radiators or underfloor pipes, offering a quiet and efficient heating solution.',
        },
        {
          title: 'Air Filtration Systems',
          description:
            "Enhance your home’s air quality with an advanced air filtration system. These systems remove dust, allergens, and other particles, ensuring cleaner air while enhancing your system's performance.",
        },
        {
          title: 'Whole-House Humidifiers',
          description:
            'Maintain ideal humidity levels with a whole-house humidifier. These systems prevent dry air, reduce static electricity, and improve overall comfort during the heating season.',
        },
      ],
    },
    {
      title: 'Our Heating Installation Process',
      image: installationImage,
      description:
        "At Tytum, we make heating installation as simple and seamless as possible for our clients. Here's a snapshot of how the process works from start to finish:",
      items: [
        {
          title: '1. Get Consultation and Assessment',
          description:
            "Our process starts with a detailed in-home consultation to assess your heating requirements. We'll evaluate your space, discuss your preferences, and assess your current system to ensure we recommend the best solution for your home.",
        },
        {
          title: '2. Select System',
          description:
            "Based on your needs, we provide tailored recommendations on the most fitting system for your home. Whether it’s a furnace, heat pump, or ductless system, we'll guide you in selecting the most efficient option that fits your budget and comfort requirements.",
        },
        {
          title: '3. Set Up and Calibration',
          description:
            "Once you've chosen the right system, our expert technicians will perform a professional installation. We ensure the system is set up efficiently and properly calibrated to maximize performance and energy efficiency from day one.",
        },
        {
          title: '4. Test System',
          description:
            'After installation, we perform testing to guarantee everything is functioning properly. Our team will ensure your system operates smoothly and effectively, addressing any questions you might have about how it works.',
        },
        {
          title: '5. Get Ongoing Support',
          description:
            'Even after the installation, you can get ongoing support. If you ever need maintenance, repairs, or got questions about the system, we’re only a call away.',
        },
      ],
      footerText:
        'Count on Tytum for professional heating installation in San Diego. Get in touch with us today to book your consultation or get a free quote online!',
    },
    {
      title: 'Advantages of Installing a New Heating System',
      description:
        'Installing a new heating system provides numerous advantages, including enhanced energy efficiency, better indoor comfort, and lower maintenance costs. Here’s a closer look at benefits of upgrading your system can enhance your living or working space.',
      items: [
        {
          title: 'Improved Energy Efficiency',
          description:
            'A new heating system is engineered to deliver efficient heating while consuming minimal energy, helping to reduce energy consumption and lower utility bills. It’s an environmentally-friendly choice that can also lower your carbon footprint.',
        },
        {
          title: 'Enhanced Indoor Comfort',
          description:
            'Modern heating systems offer more precise temperature control, allowing for consistent warmth throughout your home or business. You’ll enjoy a more comfortable environment without the fluctuations often seen in older systems.',
        },
        {
          title: 'Reduced Maintenance Costs',
          description:
            'With newer systems, you’ll experience reduced repairs and decreased maintenance expenses compared to outdated models. New technology is more reliable, reducing repair needs and extending its lifespan.',
        },
        {
          title: 'Increased Property Value',
          description:
            'An energy-efficient heating system not only keeps your home warm but can also boost its value. Potential buyers will be drawn to the long-term savings and improved comfort offered by a modern heating solution.',
        },
        {
          title: 'Quiet Operation',
          description:
            'New heating systems let you experience quieter operation compared to older models, reducing noise in your home or business. This fosters a calmer, more enjoyable living space for all occupants.',
        },
      ],
      banner: {
        title: 'Schedule Your Heating Installation Today!',
        description:
          "At Tytum, we offer professional heater installation in San Diego to ensure consistent warmth year-round. Alongside heating, we also provide expert <a href='https://tytum.com/services/heating-and-air/ac-installation'>AC installation in San Diego</a>, giving you a complete comfort solution for every season. Whether you're looking for furnace installation service or heating system replacement in San Diego, our experienced heating system installers are here to help.",
        bookServiceButton: true,
      },
    },
    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      items: [
        {
          title: '✓ How much does heating installation cost?',
          description: (
            <>
              The cost of heating installation in San Diego depends on several
              factors like system type and home size. For a personalized quote,
              reach out to us, and we’ll help you explore options suited to your
              specific wishes{' '}
              <a href="https://tytum.com/company/contact">
                Request a free estimate here
              </a>{' '}
            </>
          ),
        },
        {
          title: '✓ Curious about heating system installation time?',
          description:
            'Furnace installation in San Diego usually takes 4 to 6 hours, depending on the system. Our heating system installers work efficiently to reduce downtime and smooth the process.',
        },
        {
          title: '✓ Which heating system is perfect for my home?',
          description:
            'The ideal system will depend on factors like its size and insulation. We offer various solutions, from energy-efficient furnace installation service to reliable heating system replacement. Let us assess your needs!',
        },
        {
          title: '✓ Do you offer heating system replacement in San Diego?',
          description:
            'Yes! We provide comprehensive heating system replacement in San Diego to improve efficiency and comfort. Our heating installation services in San Diego ensure your home stays warm with the latest technology.',
        },
        {
          title:
            '✓ Can I get a free estimate for heater installation in San Diego?',
          description: (
            <>
              Absolutely! We offer free, no-obligation quotes for residential
              heating installation in San Diego. Our team will provide you with
              clear, upfront pricing and discuss the best options for your
              space.{' '}
              <a href="https://tytum.com/company/contact">
                Get your free estimate today.
              </a>{' '}
            </>
          ),
        },
      ],
      footerText:
        'Count on us as your trusted provider for heater installation in the San Diego area, ensuring your home’s comfort and safety. Call us or fill out our online form for questions or a free quote.',
    },
  ],
};
const HeatingSystemInstallationPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="circle">
        <MainSection
          label="Service Details"
          title="Heating System Installation in San Diego, CA"
          description="Stay comfortable year-round with our top-notch air conditioning installation services.
We handle everything from setup to ensuring your system performs at its best, keeping your space at the ideal temperature."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default HeatingSystemInstallationPage;
